<template>
  <div class="pa-4 detail_header" style="font-size: 24px">
    <div>{{ $props.title }}</div>
    <div class="ml-3">จำนวน <b class="ml-3 mr-3">{{ number_format($props.count) }}</b>{{ $props.type }}</div>
  </div>
</template>

<script>
import {formatNumber} from "@/js/handler";

export default {
  name: "PriceHeader",
  props: ['title', 'count', 'type'],
  methods: {
    number_format: function(value) {
      return formatNumber(value)
    }
  },
}
</script>

<style scoped>
.detail_header {
  display: flex;
}
@media only screen and (max-width: 500px) {
  .detail_header {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
}
</style>
